<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="50%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        v-loading="formLoading"
        :model="formData"
        :rules="formRules"
        label-width="120px"
      >
        <el-form-item label="试卷名称" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入"
            style="width: 400px"
            maxlength="50"
            :disabled="formType == 'view'"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择试题" prop="questionIds">
          <el-button type="primary" plain @click="openQuestionList"
            >选择试题</el-button
          >
          <span class="marginLeft10"
            >已选择{{ formData.questionIds.length }}题</span
          >
        </el-form-item>
        <el-form-item label="" :span="8" prop="singleScore">
          <span class="marginRight10">单选题：每题</span>
          <el-input-number
            v-model="formData.singleScore"
            placeholder="请输入"
            clearable
            :min="1"
            :max="10"
            controls-position="right"
            :precision="0"
            style="width: 300px"
            :disabled="formType == 'view'"
            @change="handleScoreChange"
          >
          </el-input-number>
          <span class="marginLeft10">分</span>
        </el-form-item>
        <el-form-item label="" :span="8" prop="multiScore">
          <span class="marginRight10">多选题：每题</span>
          <el-input-number
            v-model="formData.multiScore"
            placeholder="请输入"
            clearable
            :min="1"
            :max="10"
            controls-position="right"
            :precision="0"
            style="width: 300px"
            :disabled="formType == 'view'"
            @change="handleScoreChange"
          >
          </el-input-number>
          <span class="marginLeft10">分</span>
        </el-form-item>
        <div class="tip">试卷当前总分：{{ formData.totalScore }}分</div>
        <el-form-item label="" :span="8" prop="passScore">
          <span class="marginRight10">及格分数</span>
          <el-input-number
            v-model="formData.passScore"
            placeholder="请输入"
            clearable
            :min="1"
            :max="1000"
            controls-position="right"
            :precision="0"
            style="width: 300px"
            :disabled="formType == 'view'"
          >
          </el-input-number>
          <span class="marginLeft10">分</span>
        </el-form-item>
        <el-form-item label="" :span="8" prop="examTime">
          <span class="marginRight10">考试时长</span>
          <el-input-number
            v-model="formData.examTime"
            placeholder="请输入"
            clearable
            :min="5"
            :max="100"
            controls-position="right"
            :precision="0"
            style="width: 300px"
            :disabled="formType == 'view'"
          >
          </el-input-number>
          <span class="marginLeft10">分钟</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="flex" style="justify-content: center">
          <el-button
            :disabled="formLoading"
            type="primary"
            @click="submitForm"
            v-if="formType != 'view'"
            >保 存</el-button
          >
          <el-button @click="dialogVisible = false">
            {{ formType == "view" ? "关 闭" : "取 消" }}</el-button
          >
        </div>
      </template>
    </el-dialog>
    <div style="z-index: -1" v-if="questionsShow">
      <!-- 选择试题 -->
      <el-dialog
        title="选择试题"
        :visible.sync="questionsShow"
        width="60%"
        :before-close="handleCloseQuestions"
        :close-on-click-modal="false"
        append-to-body
      >
        <questionList
          :tableData="questionsList"
          :page="page"
          :questionIds="formData.questionIds"
          @handleSearch="handleSearch"
          @handleReset="handleReset"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSave="handleSave"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import {
  questionTestAdd,
  questionTestUpdate,
  questionTestView,
} from "@/api/question/test";
import { questionManageList } from "@/api/question/manage";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";

import questionList from "../components/questionList.vue";
export default {
  name: "index",
  components: {
    questionList,
  },
  props: {},
  data() {
    return {
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      formData: {
        name: "",
        questionIds: [],
        multiScore: "",
        examTime: "",
        passScore: "",
        singleScore: "",
        totalScore: "",
      },
      formRules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        questionIds: [
          { required: true, message: "请选择试题", trigger: "blur" },
        ],
        passScore: [{ required: true, message: "请输入", trigger: "blur" }],
        multiScore: [{ required: true, message: "请输入", trigger: "blur" }],
        examTime: [{ required: true, message: "请输入", trigger: "blur" }],
        singleScore: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      // 表格搜索条件
      searchData: {
        code: "",
        title: "",
        type: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      questionsShow: false,
      questionsList: [],
    };
  },
  created() {},
  methods: {
    // const formRef = ref() // 表单 Ref
    /** 打开弹窗 */
    async open(type, id) {
      this.dialogVisible = true;
      this.dialogTitle =
        type === "view" ? "详情" : type === "create" ? "新增试卷" : "修改试卷";
      this.formType = type;
      this.resetForm();
      this.onLoad();
      // 修改时，设置数据
      if (id) {
        this.formLoading = true;
        try {
          const { data } = await questionTestView(id);

          this.formData = {
            ...data,
            questionIds: data.quesStr ? JSON.parse(data.quesStr) : [],
          };
          console.log(this.formData, "formData");
        } finally {
          this.formLoading = false;
        }
      }
    },
    async submitForm() {
      // 校验表单

      if (!this.$refs.formRef) return;
      const valid = await this.$refs.formRef.validate();

      if (!valid) return;
      const newData = {
        ...this.formData,
        quesStr: this.formData.questionIds,
        questionIds: this.formData.questionIds.map((item) => item.id).join(","),
      };

      try {
        this.formLoading = true;
        if (this.formType === "create") {
          const res = await questionTestAdd(newData);
          if (res.code == 200) {
            Message.success("新增成功");
          }
        } else {
          const res = await questionTestUpdate(newData);
          if (res.code == 200) {
            Message.success("修改成功");
          }
        }
        this.dialogVisible = false;
        // 发送操作成功的事件
        this.$emit("success");
        // setTimeout(() => {
        this.formLoading = false;
        // }, 1000);
      } catch (e) {
        // this.$message.error(e);
        this.formLoading = false;
      } finally {
      }
    },

    // 重置
    resetForm() {
      this.formData = {
        name: "",
        questionIds: [],
        multiScore: "",
        examTime: "",
        passScore: "",
        singleScore: "",
        totalScore: "",
      };
    },
    handleClose() {
      this.dialogVisible = false;
    },
    openQuestionList() {
      this.questionsShow = true;

      this.questionsList.forEach((item) => {
        if (this.formData.questionIds.some((q) => q.id === item.id)) {
          item.isChecked = true;
        }
      });
      // checkedList
    },
    // 试题 相关
    onLoad() {
      const searchForm = {
        path: this.$route.path,
        searchData: this.searchData,
      };
      this.showLoading = true;
      questionManageList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.questionsList = res.data.records.map((item, index) => {
            return {
              ...item,
              isChecked: false,
              indexOf:
                (this.page.currentPage - 1) * this.page.pageSize + index + 1,
            };
          });
          this.page.total = res.data.total;
        }
      });
    },
    handleSearch(searchData) {
      this.searchData = searchData;
      this.onLoad();
    },
    handleReset() {
      this.searchData = {};
    },
    handleSizeChange(size) {
      this.page.pageSize = size;
      this.onLoad();
    },
    handleCurrentChange(current) {
      this.page.currentPage = current;
      this.onLoad();
    },
    handleCloseQuestions() {
      this.questionsShow = false;
    },
    handleSave(e) {
      console.log("保存", e);
      this.formData.questionIds = e;
      this.questionsShow = false;
      this.handleScoreChange();
    },
    handleScoreChange(e) {
      // 计算总分
      let totalScore = 0;
      // 遍历已选试题,根据题目类型计算分数
      this.formData.questionIds.forEach((item) => {
        if (item.type === 1) {
          // 单选题
          totalScore += Number(this.formData.singleScore);
        } else if (item.type === 2) {
          // 多选题
          totalScore += Number(this.formData.multiScore);
        }
      });
      this.formData.totalScore = totalScore;
    },
  },
};
</script>
<style scoped>
.video_box {
  margin-left: 3%;
  margin-bottom: 10px;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
}
.details_box {
  margin-right: 10%;
  max-width: 100%;
  overflow: hidden;
}
.details_box p img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
:deep(.el-input__inner) {
  text-align: left;
}
.tip {
  margin-left: 13%;
  font-weight: bold;
  margin-bottom: 10px;
}
/deep/.v-modal {
  z-index: 0 !important;
}
</style>
